import {GetPinSsUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetPinSsUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetPinSsUrl = (): GetPinSsUrl =>
	new RemoteGetPinSsUrl(
		makeBFFApiUrl(ExternalLinkPoint.pinSs),
		makeAuthorizeHttpClientDecorator(),
	);
